import PrescriptionFillsManualEntryContainer from './prescription-fills-manual-entry-container';

export default PrescriptionFillsManualEntryContainer;
